import { combineEpics, type Epic } from 'redux-observable';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { serverUpdateAllRequest } from '@/api/matches';
import { startOfDay } from '@/utils';
import { clearAll, serverUpdateAll, tryFetchDailyMatches } from '../actions';
import { selectedDate } from '../selectors';

const serverUpdateAllEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(serverUpdateAll.match),
    withLatestFrom(state$),
    map(([action, state]) => ({
      ...action,
      payload: {
        editedMatches: state.matches.editedMatches,
        editedCompetitions: state.matches.editedCompetitions,
        addLiveBlog: state.matches.addLiveBlog,
        addHomeWidget: state.matches.addHomeWidget,
        syncMatchData: state.matches.syncMatchData,
      },
    })),
    request(({ payload }) => serverUpdateAllRequest(payload), serverUpdateAll),
  );

const serverUpdateAllSucceededEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(serverUpdateAll.succeeded.match),
    withLatestFrom(state$),
    mergeMap(([, state]) => {
      const day = selectedDate(state);
      return [
        openSnackbar({
          snackbarType: 'success',
          snackbarMessage: 'Οι αλλαγές σας έχουν αποθηκευτεί',
        }),
        clearAll(),
        tryFetchDailyMatches(day || startOfDay()),
      ];
    }),
  );

export default combineEpics(serverUpdateAllEpic, serverUpdateAllSucceededEpic);
